module.exports = __webpack_public_path__ + "img/00016.79240f22.webp";